import { defaultFirebasePerformance } from '@/utils/firebase'
import { trace as createTrace, PerformanceTrace } from 'firebase/performance'

export class CustomTrace {
  private traces: { [key: string]: PerformanceTrace | undefined } = {}

  public async startTrace(spanName: string): Promise<void> {
    const trace = createTrace(defaultFirebasePerformance, spanName)
    trace.start()
    this.traces[spanName] = trace
  }

  public async stopTrace(spanName: string): Promise<void> {
    const trace = this.traces[spanName]
    if (!trace) {
      return
    }
    trace.stop()
    delete this.traces[spanName]
  }

  public async record(
    spanName: string,
    startTime: number,
    duration: number,
    attributes?: { [key: string]: string }
  ): Promise<void> {
    const trace = createTrace(defaultFirebasePerformance, spanName)
    trace.record(startTime, duration, { attributes: attributes })
  }
}

export const CustomTraceProvider = new CustomTrace()
